import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { ROUTES_DRUG } from "commons/constants/paths";
import { useAppDispatch, useAppSelector } from "commons/store/hooks";
import DashboardLayoutWrapper from "commons/wrappers/DashboardLayoutWrapper";
import ColoredBox from "components/ColoredBox";
import ConfirmationAction from "components/ConfirmationAction";
import { Table } from "components/Table";
import {
  deleteResource,
  fetchResources,
  selectResources,
} from "features/drugs/redux/drugsSlice";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const DrugsList = () => {
  const [page, setPage] = useState(1);
  const dispatch = useAppDispatch();
  const data = useAppSelector(selectResources);

  useEffect(() => {
    dispatch(fetchResources({ page }));
  }, [dispatch, page]);

  const handleDelete = async (id: string) => {
    await dispatch(deleteResource(id));
    dispatch(fetchResources({ page }));
  };

  return (
    <DashboardLayoutWrapper>
      <Box display="flex" justifyContent="flex-end" mb={2}>
        <Button
          component={Link}
          to={ROUTES_DRUG.ADD}
          variant="contained"
          color="primary"
        >
          Dodaj lek
        </Button>
      </Box>
      <ColoredBox p={1} maxWidth="100%" ml="auto" mr="auto">
        <Table
          pagination={{
            pageSize: data.itemsPerPage,
            current: page,
            total: data.totalItems,
          }}
          onChangePage={(page) => setPage(page)}
          data={data.data}
          tableName="Leki"
          columns={[
            {
              title: "Nazwa",
              render: (row) => row.name,
              key: "name",
            },
            {
              title: "Actions",
              noWrap: true,
              render: (row) => (
                <div>
                  <Box mr={1} display="inline-flex">
                    <Button
                      component={Link}
                      to={ROUTES_DRUG.EDIT(row.id || "")}
                      variant="contained"
                      color="primary"
                      size="small"
                    >
                      Edytuj
                    </Button>
                  </Box>
                  <ConfirmationAction
                    onClick={() => handleDelete(row.id || "")}
                  >
                    {({ handleClick }) => (
                      <Button
                        type="button"
                        onClick={handleClick}
                        variant="contained"
                        size="small"
                        color="primary"
                      >
                        Usuń
                      </Button>
                    )}
                  </ConfirmationAction>
                </div>
              ),
              key: "actions",
            },
          ]}
        />
      </ColoredBox>
    </DashboardLayoutWrapper>
  );
};

export default DrugsList;
